import { proxy } from 'valtio';
import {
	ApplicationsFilter,
	FunctionaryList,
	GetCandidatesLoadSummaryResponse,
	GetProposerLoadSummaryResponse,
	GetZonesProposerLoadSummaryResponse,
	PagingConfig,
	ProposerFilter,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';

export const ProposerListState = proxy<{
	filterBy: ApplicationsFilter | ProposerFilter | undefined;
	paging: PagingConfig;
	proposerLoadSummaryResponse: GetProposerLoadSummaryResponse;
	candidatesLoadSummaryResponse: GetCandidatesLoadSummaryResponse;
	availableFunctionariesResponse: FunctionaryList;
	zonesProposerLoadResponse: GetZonesProposerLoadSummaryResponse;
}>({
	filterBy: undefined,
	paging: {
		pageNo: 1,
		pageSize: DEFAULT_PAGE_SIZE,
	},
	proposerLoadSummaryResponse: {
		proposerLoadSummary: [],
		pagination: { totalNoOfRecords: 0 },
	},
	candidatesLoadSummaryResponse: {
		candidateLoadDetail: [],
		zoneName: '',
		pagination: { totalNoOfRecords: 0 },
	},
	availableFunctionariesResponse: {
		functionary: [],
		pagination: { totalNoOfRecords: 0 },
	},
	zonesProposerLoadResponse: {
		zonesProposerLoadSummary: [],
		pagination: { totalNoOfRecords: 0 },
	},
});
